import { FC, useEffect, useState } from 'react';
import { ProAutoComplete } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getInputPlaceholder } from '../utils/ruleUtils';
import { filterStrSpace } from '../utils/utils';
import { AutoCompleteProps } from 'antd/lib/auto-complete';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { DefaultOptionType } from 'antd/lib/select';

export type AutoCompleteType = 'email';
export interface BaseAutoCompleteProps extends AutoCompleteProps {
  /** 输入类型 */
  type?: AutoCompleteType;
  /** 邮箱后缀 */
  emailSuffixs?: string[];
}
export interface SearchFormAutoCompleteProps extends BaseSearchFormItemProps {
  /** AutoComplete Props */
  autoCompleteProps?: BaseAutoCompleteProps;
}
/** 自动完成输入框 */
export const SearchFormAutoComplete: FC<SearchFormAutoCompleteProps> = props => {
  const {
    autoCompleteProps,
    render,
    disabledRender,
    isDetail,
    isTable,
    testId,
    rules,
    label,
    name,
    form,
    className,
    copy,
    ...resProps
  } = props;
  const [options, setOptions] = useState<DefaultOptionType[]>();
  useEffect(() => {
    setOptions(autoCompleteProps?.options);
  }, [autoCompleteProps?.options]);
  const handleSearch = (value: string) => {
    let newOption: DefaultOptionType[] = []
    if (autoCompleteProps?.type === 'email') {
      if (!value || value.indexOf('@') >= 0) {
        newOption = [];
      } else {
        autoCompleteProps.emailSuffixs?.forEach(v => {
          const labelOrValue = `${value}@${v}`;
          newOption.push({label: labelOrValue, value: labelOrValue});
        });
      }
      setOptions(newOption);
    }
    autoCompleteProps?.onSearch?.(value);
  };
  const normFile = (value: string) => {
    const currentValue = value;
    if (currentValue === ' ' || currentValue === undefined) return currentValue;
    return filterStrSpace(currentValue, 'left');
  };
  return (
    <SearchFormItem
      getValueFromEvent={normFile}
      name={name}
      {...resProps}
      disabled={isDetail || autoCompleteProps?.disabled}
      label={label}
      rules={rules}
    >
      {isDetail || (autoCompleteProps && autoCompleteProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          render={render || disabledRender}
          isTable={isTable}
          copy={copy}
        />
      ) : (
        <ProAutoComplete
          placeholder={getInputPlaceholder(label, autoCompleteProps, rules)}
          onSearch={handleSearch}
          options={options}
          {...autoCompleteProps}
          test-id={`${testId}-${name}`}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormAutoComplete.displayName = SearchFormItemEnum.SearchFormAutoComplete;

export default SearchFormAutoComplete;
